module.exports = __webpack_public_path__ + "img/icon-slider-02-academy-template.09477350.svg";